import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  getHydratedFeatureFlags,
  isDemoFeatureAllowed,
  isGpsLiveAllowed,
  isRoutesPlannerAllowed,
  type ClientFeatureFlags,
} from '../config/featureFlags';

type FlagKey = keyof ClientFeatureFlags;

export const RequireFeatureFlag: React.FC<{
  flag: FlagKey;
  children: React.ReactNode;
  fallback?: string;
}> = ({ flag, children, fallback = '/dashboard' }) => {
  if (!getHydratedFeatureFlags()[flag]) {
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
};

export const RequireDemoAllowed: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isDemoFeatureAllowed()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export const RequireGpsLive: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isGpsLiveAllowed()) {
    return <Navigate to="/tracking" replace />;
  }
  return <>{children}</>;
};

export const RequireRoutesPlanner: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isRoutesPlannerAllowed()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};
